<ng-container *ngIf="isLoading; then loading else content"></ng-container>

<ng-template #loading>
  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>

  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>

  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>

  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
</ng-template>

<ng-template #content>
  <h2 class="panel-title">{{('Modules.RemoteMaintenance.AllStores' | translate)}}</h2>
  <app-search-bar
    [title]="'Modules.RemoteMaintenance.Filter' | translate"
    [placeholder]="'Modules.RemoteMaintenance.FilterInfo' | translate"
    [searchText]="searchText"
    (onSearchTextChanged)="onSearchTextChanged($event)">
  </app-search-bar>

  @if (canFilterByCompany()) {
  <app-input type="menu" [ngModel]="getCompanyDisplayName()" (click)="openCompanyDialog()"
    label="{{ 'Modules.RemoteMaintenance.CompanyTitle' | translate }}"></app-input>
  }

  <app-input type="menu" [(ngModel)]="filterDisplayString" (click)="openFilterDialog()"
    label="{{ 'Modules.RemoteMaintenance.FiltersTitle' | translate }}"></app-input>

  <app-input type="options" [(ngModel)]="sortOrder" (change)="refreshData()" [basicOptions]="sortOptions"
    basicTranslateKey="Modules.RemoteMaintenance.SortOrders"
    label="{{ 'Modules.RemoteMaintenance.SortOrder' | translate }}"></app-input>

  <app-input type="options" [(ngModel)]="controllerType" (change)="refreshData()" [basicOptions]="controllerTypeOptions"
    basicTranslateKey="Modules.RemoteMaintenance.ControllerTypes"
    label="{{ 'Modules.RemoteMaintenance.ControllerType' | translate }}"></app-input>

  @if (controllerType === 'all' || controllerType === 'ccap') {
    <p class="p-formfield-info">{{ 'Modules.RemoteMaintenance.ControllerTypeInfo' | translate }}</p>
  }

  <div class="action-buttons">
    <ng-container>
      <button mat-flat-button class="button small-button" (click)="refreshData()">
        <mat-icon>autorenew</mat-icon>
        <p>{{ 'Modules.RemoteMaintenance.Refresh' | translate }}</p>
      </button>
    </ng-container>
  </div>

  <h2 class="panel-title">{{('Modules.RemoteMaintenance.Cloud' | translate)}} ({{ filteredLastInstalledDevices.length }}{{ hasMore ? '+' : '' }})</h2>
  <p class="p-formfield-info">{{ getListInfoText() }}</p>

  <div *ngIf="!isLoadingFilteredDevices && filteredLastInstalledDevices.length" >
    <app-list-item *ngFor="let xpac of filteredLastInstalledDevices"
    (onClickCallback)="remoteXPACInfo(xpac)"
    [title]="getTitleString(xpac)"
    [showActionIcon]="true"
    [info]="getXpacInfoStringIdAndInstallationDate(xpac)"
    [info2]="getXpacInfoStringAddressAndRetailer(xpac)"
    [itemStatusBadge]="getProblemsNumber(xpac)"
    [disabledColorText]="!xpac.isConnected"
    showItemStatus="true"
    [itemStatusIcons]="getStatusIcon(xpac)">
    </app-list-item>

    <div class="action-buttons" *ngIf="hasMore">
      <ng-container *ngIf="isLoadingMore; then loading else loadAction"></ng-container>

      <ng-template #loadAction>
        <button mat-flat-button class="button small-button" (click)="loadMore()">
          <mat-icon>update</mat-icon>
          <p>{{ 'General.LoadMore' | translate }}</p>
        </button>
      </ng-template>

      <ng-template #loading>
        <mat-spinner class="spinner" diameter="28"></mat-spinner>
      </ng-template>
    </div>
  </div>

  <div *ngIf="isLoadingFilteredDevices">
    <mat-spinner class="spinner" diameter="28"></mat-spinner>
  </div>

   <!-- No devices -->
   <div class="panel-no-data" *ngIf="!filteredLastInstalledDevices.length && !isLoadingFilteredDevices">
    {{ (searchText.length > 0 ? 'Modules.RemoteMaintenance.NoStoresFiltered' : 'Modules.RemoteMaintenance.NoStores') | translate: { filter: searchText } }}
  </div>

</ng-template>
